import { InputGroup, OverlayTrigger, Tooltip } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCirclePlus, faCircleMinus } from '@fortawesome/free-solid-svg-icons';
import { IncludeExclude } from "../../utils/types";
import { useEffect, useState } from "react";

interface AutocompleteIncludeExcludeProps {
  defaultIncludeExclude?: IncludeExclude;
  includeExcludeOnChange?: (newIncludeExclude:IncludeExclude) => void;
  disabled?: boolean;
}

export default function AutocompleteIncludeExclude(props:AutocompleteIncludeExcludeProps) {
  const { defaultIncludeExclude, includeExcludeOnChange, disabled } = props;
  const [includeExclude, setIncludeExclude] = useState(defaultIncludeExclude);

  const handleSwitchChange = () => {
    if (!disabled) {
      const newIncludeExclude = includeExclude === IncludeExclude.Include ? IncludeExclude.Exclude : IncludeExclude.Include;
      includeExcludeOnChange(newIncludeExclude);
      setIncludeExclude(newIncludeExclude);
    }
  };

  useEffect(() => {
    setIncludeExclude(defaultIncludeExclude);
  }, [defaultIncludeExclude]);

  if (disabled) {
    return (
      <InputGroup.Prepend>
        <InputGroup.Text onClick={handleSwitchChange} style={{ width: "28px", height: "28px", padding: "5px" }}>
          <FontAwesomeIcon
            icon={includeExclude === IncludeExclude.Include ? faCirclePlus : faCircleMinus}
            style={{ color: "lightgray", userSelect: 'none' }}
          />
        </InputGroup.Text>
      </InputGroup.Prepend>
    );
  }

  return (
    <InputGroup.Prepend>
      <OverlayTrigger
        key="include-exclude-tooltip"
        placement="auto"
        overlay={( props ) => {
          return (
            <Tooltip {...props} id="include-exclude-tooltip">
              {
                includeExclude === IncludeExclude.Include ?
                  <div>Include Mode: Search currently returns only rows matching this filter. Click to change to Exclude Mode.</div>
                :
                  <div>Exclude Mode: Search currently excludes rows matching this filter (all other rows are included). Click to change to Include Mode.</div>
              }
            </Tooltip>
          );
        }}
      >
        <InputGroup.Text onClick={handleSwitchChange} style={{ cursor: 'pointer', width: "28px", height: "28px", padding: "5px" }}>
          <FontAwesomeIcon
            icon={includeExclude === IncludeExclude.Include ? faCirclePlus : faCircleMinus}
            style={{ color: includeExclude === IncludeExclude.Include ? "#A9A9A9" : "red", userSelect: 'none' }}
          />
        </InputGroup.Text>
      </OverlayTrigger>
    </InputGroup.Prepend>
  );
}